import React, { useState, useEffect } from 'react';
import axios from 'axios';

const HistoricoCompleto = ({
  API,
  getAuthHeaders,
  setCurrentView,
  currentUser
}) => {
  const [loading, setLoading] = useState(false);
  const [domingosList, setDomingosList] = useState([]);
  const [totalGeral, setTotalGeral] = useState({});
  const [filtroTipo, setFiltroTipo] = useState('mes'); // mes, trimestre, ano, personalizado
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Definir período baseado no filtro
  const definirPeriodo = (tipo) => {
    const hoje = new Date();
    let inicio, fim;

    switch(tipo) {
      case 'mes':
        // Últimos domingos com possibilidade de dados
        inicio = new Date(2025, 8, 1); // Setembro 2025 (mês 8)
        fim = new Date();
        break;
      case 'trimestre':
        // Últimos 3 meses a partir de agosto
        inicio = new Date(2025, 7, 1); // Agosto 2025 (mês 7)
        fim = new Date();
        break;
      case 'ano':
        // Ano de 2025
        inicio = new Date(2025, 0, 1); // Janeiro 2025
        fim = new Date();
        break;
      case 'personalizado':
        return; // Não alterar as datas
      default:
        inicio = hoje;
        fim = hoje;
    }

    setStartDate(inicio.toISOString().split('T')[0]);
    setEndDate(fim.toISOString().split('T')[0]);
  };

  // Executar definirPeriodo quando filtroTipo mudar E carregar dados imediatamente
  useEffect(() => {
    if (filtroTipo !== 'personalizado') {
      definirPeriodo(filtroTipo);
      // Forçar carregamento após definir período
      setTimeout(() => {
        loadHistoricDataInternal();
      }, 100);
    }
  }, [filtroTipo]);

  // Função interna para carregar dados
  const loadHistoricDataInternal = async () => {
    const currentStartDate = startDate || new Date(2025, 8, 1).toISOString().split('T')[0];
    const currentEndDate = endDate || new Date().toISOString().split('T')[0];

    if (!currentStartDate || !currentEndDate) {
      return;
    }

    setLoading(true);
    try {

      // Buscar dados de dashboard para cada domingo no período
      const domingosDados = [];
      const start = new Date(currentStartDate);
      const end = new Date(currentEndDate);
      const current = new Date(start);

      while (current <= end) {
        if (current.getDay() === 0) { // É domingo
          const domingoStr = current.toISOString().split('T')[0];

          try {
            const response = await axios.get(`${API}/reports/dashboard?data=${domingoStr}`, { headers: getAuthHeaders() });


            if (response.data && response.data.length > 0) {
              // Calcular totais do domingo
              const totais = {
                data: domingoStr,
                dataFormatada: current.toLocaleDateString('pt-BR'),
                matriculados: response.data.reduce((sum, row) => sum + (row.matriculados || 0), 0),
                presentes: response.data.reduce((sum, row) => sum + (row.presentes || 0), 0),
                ausentes: response.data.reduce((sum, row) => sum + (row.ausentes || 0), 0),
                visitantes: response.data.reduce((sum, row) => sum + (row.visitantes || 0), 0),
                pos_chamada: response.data.reduce((sum, row) => sum + (row.pos_chamada || 0), 0),
                ofertas: response.data.reduce((sum, row) => sum + (row.total_ofertas || 0), 0),
                biblias: response.data.reduce((sum, row) => sum + (row.total_biblias || 0), 0),
                revistas: response.data.reduce((sum, row) => sum + (row.total_revistas || 0), 0)
              };


              // Calcular porcentagem
              totais.porcentagem = totais.matriculados > 0 ?
                ((totais.presentes / totais.matriculados) * 100).toFixed(1) : '0.0';

              // Só incluir domingos que tenham pelo menos 1 presença OU que tenha ofertas/visitantes
              if (totais.presentes > 0 || totais.visitantes > 0 || totais.ofertas > 0) {
                domingosDados.push(totais);
              } else {
              }
            }
          } catch (error) {
          }
        }
        current.setDate(current.getDate() + 1);
      }

      // Ordenar por data (mais recente primeiro)
      domingosDados.sort((a, b) => new Date(b.data) - new Date(a.data));

      // Calcular total geral
      const totalGeral = {
        matriculados: domingosDados.reduce((sum, d) => sum + d.matriculados, 0),
        presentes: domingosDados.reduce((sum, d) => sum + d.presentes, 0),
        ausentes: domingosDados.reduce((sum, d) => sum + d.ausentes, 0),
        visitantes: domingosDados.reduce((sum, d) => sum + d.visitantes, 0),
        pos_chamada: domingosDados.reduce((sum, d) => sum + d.pos_chamada, 0),
        ofertas: domingosDados.reduce((sum, d) => sum + d.ofertas, 0),
        biblias: domingosDados.reduce((sum, d) => sum + d.biblias, 0),
        revistas: domingosDados.reduce((sum, d) => sum + d.revistas, 0),
        totalDomingos: domingosDados.length
      };

      // Calcular média de porcentagem
      const somaPercentuais = domingosDados.reduce((sum, d) => sum + parseFloat(d.porcentagem), 0);
      totalGeral.porcentagemMedia = domingosDados.length > 0 ?
        (somaPercentuais / domingosDados.length).toFixed(1) : '0.0';

      setDomingosList(domingosDados);
      setTotalGeral(totalGeral);

    } catch (error) {
      alert('Erro ao carregar dados históricos: ' + error.message);
    }
    setLoading(false);
  };

  // Carregar histórico completo (expandido da lógica que funciona)
  const loadHistoricData = async () => {
    setLoading(true);

    // Definir período baseado no filtro atual
    let inicioData, fimData;
    const hoje = new Date();

    switch(filtroTipo) {
      case 'mes':
        inicioData = new Date(2025, 8, 1); // Setembro 2025
        fimData = new Date();
        break;
      case 'trimestre':
        inicioData = new Date(2025, 7, 1); // Agosto 2025
        fimData = new Date();
        break;
      case 'ano':
        inicioData = new Date(2025, 0, 1); // Janeiro 2025
        fimData = new Date();
        break;
      case 'personalizado':
        inicioData = startDate ? new Date(startDate) : new Date(2025, 8, 1);
        fimData = endDate ? new Date(endDate) : new Date();
        break;
      default:
        inicioData = new Date(2025, 8, 1);
        fimData = new Date();
    }

    try {
      const domingosDados = [];
      const current = new Date(inicioData);

      // Buscar cada domingo no período (mesma lógica que funcionou no teste)
      while (current <= fimData) {
        if (current.getDay() === 0) { // É domingo
          const domingoStr = current.toISOString().split('T')[0];

          try {
            const response = await axios.get(`${API}/reports/dashboard?data=${domingoStr}`, { headers: getAuthHeaders() });

            if (response.data && response.data.length > 0) {
              // Usar EXATAMENTE a mesma lógica que funcionou no teste
              const totais = {
                data: domingoStr,
                dataFormatada: current.toLocaleDateString('pt-BR'),
                matriculados: response.data.reduce((sum, row) => sum + (row.matriculados || 0), 0),
                presentes: response.data.reduce((sum, row) => sum + (row.presentes || 0), 0),
                ausentes: response.data.reduce((sum, row) => sum + (row.ausentes || 0), 0),
                visitantes: response.data.reduce((sum, row) => sum + (row.visitantes || 0), 0),
                pos_chamada: response.data.reduce((sum, row) => sum + (row.pos_chamada || 0), 0),
                ofertas: response.data.reduce((sum, row) => sum + (row.total_ofertas || 0), 0),
                biblias: response.data.reduce((sum, row) => sum + (row.total_biblias || 0), 0),
                revistas: response.data.reduce((sum, row) => sum + (row.total_revistas || 0), 0)
              };

              totais.porcentagem = totais.matriculados > 0 ?
                ((totais.presentes / totais.matriculados) * 100).toFixed(1) : '0.0';

              // Só incluir se tiver atividade real
              if (totais.presentes > 0 || totais.visitantes > 0 || totais.ofertas > 0) {
                domingosDados.push(totais);
              }
            }
          } catch (error) {
            // Ignorar domingos sem dados silenciosamente
          }
        }
        current.setDate(current.getDate() + 1);
      }

      // Ordenar por data (mais recente primeiro)
      domingosDados.sort((a, b) => new Date(b.data) - new Date(a.data));

      // Calcular totais (mesma lógica do teste)
      const totalGeral = {
        totalDomingos: domingosDados.length,
        matriculados: domingosDados.reduce((sum, d) => sum + d.matriculados, 0),
        presentes: domingosDados.reduce((sum, d) => sum + d.presentes, 0),
        ausentes: domingosDados.reduce((sum, d) => sum + d.ausentes, 0),
        visitantes: domingosDados.reduce((sum, d) => sum + d.visitantes, 0),
        pos_chamada: domingosDados.reduce((sum, d) => sum + d.pos_chamada, 0),
        ofertas: domingosDados.reduce((sum, d) => sum + d.ofertas, 0),
        biblias: domingosDados.reduce((sum, d) => sum + d.biblias, 0),
        revistas: domingosDados.reduce((sum, d) => sum + d.revistas, 0)
      };

      // Calcular média de porcentagem
      const somaPercentuais = domingosDados.reduce((sum, d) => sum + parseFloat(d.porcentagem), 0);
      totalGeral.porcentagemMedia = domingosDados.length > 0 ?
        (somaPercentuais / domingosDados.length).toFixed(1) : '0.0';

      // Aplicar ao estado (mesma forma que funcionou)
      setDomingosList(domingosDados);
      setTotalGeral(totalGeral);


    } catch (error) {
      alert('Erro ao carregar histórico: ' + error.message);
      setDomingosList([]);
      setTotalGeral({});
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-900 via-green-800 to-teal-900 text-white px-4 sm:px-6 py-4 shadow-lg">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-3 sm:space-y-0">
          <button
            onClick={() => setCurrentView('dashboard')}
            className="self-start px-3 py-2 bg-white bg-opacity-20 text-white rounded-lg hover:bg-opacity-30 transition-all duration-200 text-sm font-medium touch-manipulation"
          >
            ← Voltar ao Dashboard
          </button>

          <div className="text-center sm:flex-1 sm:mx-6">
            <h1 className="text-xl sm:text-2xl font-bold">💰 Faturamento</h1>
            <p className="text-green-200 text-sm mt-1 hidden sm:block">Controle financeiro e histórico de arrecadações</p>
            <p className="text-green-200 text-sm mt-1 sm:hidden">Controle financeiro</p>
          </div>

          <div className="text-right text-sm hidden sm:block">
            <p>Sistema EBD</p>
          </div>
        </div>
      </div>

      {/* Filtros */}
      <div className="max-w-7xl mx-auto mt-4 px-4">
        <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg mb-6">
          <h3 className="text-lg font-semibold text-gray-800 mb-4">🔍 Filtros de Período</h3>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
            <button
              onClick={() => setFiltroTipo('mes')}
              className={`px-4 py-3 rounded-lg font-medium transition-colors touch-manipulation ${
                filtroTipo === 'mes'
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              <span className="block sm:hidden">📅</span>
              <span className="hidden sm:block">📅 30 Dias</span>
            </button>
            <button
              onClick={() => setFiltroTipo('trimestre')}
              className={`px-4 py-3 rounded-lg font-medium transition-colors touch-manipulation ${
                filtroTipo === 'trimestre'
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              <span className="block sm:hidden">📊</span>
              <span className="hidden sm:block">📊 90 Dias</span>
            </button>
            <button
              onClick={() => setFiltroTipo('ano')}
              className={`px-4 py-3 rounded-lg font-medium transition-colors touch-manipulation ${
                filtroTipo === 'ano'
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              <span className="block sm:hidden">📈</span>
              <span className="hidden sm:block">📈 365 Dias</span>
            </button>
            <button
              onClick={() => setFiltroTipo('personalizado')}
              className={`px-4 py-3 rounded-lg font-medium transition-colors touch-manipulation ${
                filtroTipo === 'personalizado'
                  ? 'bg-green-600 text-white shadow-lg'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              <span className="block sm:hidden">⚙️</span>
              <span className="hidden sm:block">⚙️ Personalizado</span>
            </button>
          </div>

          {filtroTipo === 'personalizado' && (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Data Inicial</label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Data Final</label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full px-4 py-3 text-base border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              <div className="flex items-end">
                <button
                  onClick={loadHistoricData}
                  disabled={loading}
                  className="w-full px-4 py-3 text-base bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors duration-200 font-medium touch-manipulation"
                >
                  {loading ? '🔄 Carregando...' : '📊 Gerar Histórico'}
                </button>
              </div>
            </div>
          )}

          {filtroTipo !== 'personalizado' && (
            <div className="text-center">
              <p className="text-sm text-gray-600 mb-4">
                Filtro selecionado: <strong>{
                  filtroTipo === 'mes' ? 'Últimos 30 dias (Set/2025)' :
                  filtroTipo === 'trimestre' ? 'Últimos 90 dias (Ago-Set/2025)' :
                  filtroTipo === 'ano' ? 'Ano completo (2025)' : 'Período personalizado'
                }</strong>
              </p>
              <button
                onClick={loadHistoricData}
                disabled={loading}
                className="px-6 py-3 text-base bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:bg-gray-400 transition-colors duration-200 font-medium"
              >
                {loading ? '🔄 Carregando...' : '📊 Carregar Histórico'}
              </button>
            </div>
          )}
        </div>

        {/* Estatísticas Gerais */}
        {domingosList.length > 0 && (
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg mb-6">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">📈 Estatísticas do Período</h3>
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              <div className="bg-green-50 p-4 rounded-lg text-center">
                <div className="text-2xl sm:text-3xl font-bold text-green-600">{totalGeral.totalDomingos}</div>
                <div className="text-sm sm:text-base text-green-700 mt-1">Domingos</div>
              </div>
              <div className="bg-blue-50 p-4 rounded-lg text-center">
                <div className="text-2xl sm:text-3xl font-bold text-blue-600">{totalGeral.presentes}</div>
                <div className="text-sm sm:text-base text-blue-700 mt-1">Total Presenças</div>
              </div>
              <div className="bg-red-50 p-4 rounded-lg text-center">
                <div className="text-2xl sm:text-3xl font-bold text-red-600">{totalGeral.ausentes}</div>
                <div className="text-sm sm:text-base text-red-700 mt-1">Total Ausentes</div>
              </div>
              <div className="bg-purple-50 p-4 rounded-lg text-center">
                <div className="text-2xl sm:text-3xl font-bold text-purple-600">R$ {totalGeral.ofertas?.toFixed(2)?.replace('.', ',') || '0,00'}</div>
                <div className="text-sm sm:text-base text-purple-700 mt-1">Total Ofertas</div>
              </div>
            </div>
          </div>
        )}


        {/* Lista de Domingos */}
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <div className="bg-green-50 px-6 py-4 border-b border-green-200">
            <h3 className="text-lg font-semibold text-green-800">💰 Faturamento por Domingo</h3>
            <p className="text-sm text-green-600 mt-1">
              Arrecadações e estatísticas por domingo no período selecionado
            </p>
          </div>

          {loading ? (
            <div className="p-8 text-center">
              <div className="text-4xl mb-4">🔄</div>
              <p className="text-gray-600">Carregando dados históricos...</p>
            </div>
          ) : domingosList.length === 0 ? (
            <div className="p-8 text-center">
              <div className="text-4xl mb-4">📅</div>
              <p className="text-gray-600 text-lg">Nenhuma chamada encontrada para o período</p>
              <p className="text-gray-500 text-sm mt-2">Tente ajustar o período ou verificar se há chamadas registradas</p>
            </div>
          ) : (
            <div>
              {/* Versão Desktop - Tabela */}
              <div className="hidden lg:block overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Data</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Matric.</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Pres.</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">%</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Aus.</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Vis.</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Pós</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Ofertas</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Bíb.</th>
                      <th className="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase">Rev.</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {domingosList.map((domingo, index) => (
                      <tr key={`${domingo.data}-${index}`} className="hover:bg-gray-50">
                        <td className="px-4 py-4">
                          <div className="font-medium text-gray-900">{domingo.dataFormatada}</div>
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.matriculados}
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.presentes}
                        </td>
                        <td className="px-4 py-4 text-center font-semibold text-purple-600">
                          {domingo.porcentagem}%
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.ausentes}
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.visitantes}
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.pos_chamada}
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-900">
                          R$ {domingo.ofertas.toFixed(2).replace('.', ',')}
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.biblias}
                        </td>
                        <td className="px-4 py-4 text-center text-sm text-gray-600">
                          {domingo.revistas}
                        </td>
                      </tr>
                    ))}

                    {/* Linha de Total */}
                    {domingosList.length > 0 && (
                      <tr className="bg-blue-50 font-semibold border-t-2 border-blue-200">
                        <td className="px-4 py-4 text-blue-800">TOTAL GERAL</td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {Math.round(totalGeral.matriculados / totalGeral.totalDomingos) || 0}
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {totalGeral.presentes}
                        </td>
                        <td className="px-4 py-4 text-center font-semibold text-purple-800">
                          {totalGeral.porcentagemMedia}%
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {totalGeral.ausentes}
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {totalGeral.visitantes}
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {totalGeral.pos_chamada}
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          R$ {totalGeral.ofertas?.toFixed(2)?.replace('.', ',') || '0,00'}
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {totalGeral.biblias}
                        </td>
                        <td className="px-4 py-4 text-center text-blue-800">
                          {totalGeral.revistas}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {/* Versão Mobile - Cards */}
              <div className="lg:hidden space-y-4">
                {domingosList.map((domingo, index) => (
                  <div key={`${domingo.data}-${index}`} className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                    <div className="flex justify-between items-center mb-3">
                      <div>
                        <h4 className="font-medium text-gray-900 text-lg">{domingo.dataFormatada}</h4>
                        <p className="text-sm text-gray-600">Domingo</p>
                      </div>
                      <div className="text-right">
                        <div className="text-xl font-bold text-purple-600">{domingo.porcentagem}%</div>
                        <div className="text-xs text-gray-500">Frequência</div>
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div>
                        <p className="text-xs text-gray-500 uppercase font-medium">Matriculados</p>
                        <p className="text-lg font-medium text-gray-900">{domingo.matriculados}</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 uppercase font-medium">Presentes</p>
                        <p className="text-lg font-medium text-blue-600">{domingo.presentes}</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 uppercase font-medium">Ausentes</p>
                        <p className="text-lg font-medium text-red-600">{domingo.ausentes}</p>
                      </div>
                      <div>
                        <p className="text-xs text-gray-500 uppercase font-medium">Visitantes</p>
                        <p className="text-lg font-medium text-green-600">{domingo.visitantes}</p>
                      </div>
                    </div>

                    <div className="border-t border-gray-100 pt-3">
                      <div className="grid grid-cols-3 gap-4 text-center">
                        <div>
                          <p className="text-xs text-gray-500 uppercase">Pós-Chamada</p>
                          <p className="text-sm font-medium text-gray-900">{domingo.pos_chamada}</p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 uppercase">Bíblias</p>
                          <p className="text-sm font-medium text-gray-900">{domingo.biblias}</p>
                        </div>
                        <div>
                          <p className="text-xs text-gray-500 uppercase">Revistas</p>
                          <p className="text-sm font-medium text-gray-900">{domingo.revistas}</p>
                        </div>
                      </div>
                      <div className="mt-3 text-center">
                        <p className="text-xs text-gray-500 uppercase">Ofertas</p>
                        <p className="text-lg font-bold text-purple-600">R$ {domingo.ofertas.toFixed(2).replace('.', ',')}</p>
                      </div>
                    </div>
                  </div>
                ))}

                {/* Card de Total Mobile */}
                {domingosList.length > 0 && (
                  <div className="bg-blue-50 border-2 border-blue-200 rounded-lg p-4 shadow-sm">
                    <h4 className="font-bold text-blue-800 text-lg mb-3 text-center">📊 TOTAL GERAL</h4>

                    <div className="grid grid-cols-2 gap-4 mb-4">
                      <div className="text-center">
                        <p className="text-xs text-blue-600 uppercase font-medium">Total Presenças</p>
                        <p className="text-xl font-bold text-blue-800">{totalGeral.presentes}</p>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-blue-600 uppercase font-medium">Total Ausentes</p>
                        <p className="text-xl font-bold text-blue-800">{totalGeral.ausentes}</p>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-blue-600 uppercase font-medium">Média %</p>
                        <p className="text-xl font-bold text-purple-800">{totalGeral.porcentagemMedia}%</p>
                      </div>
                      <div className="text-center">
                        <p className="text-xs text-blue-600 uppercase font-medium">Total Ofertas</p>
                        <p className="text-xl font-bold text-blue-800">R$ {totalGeral.ofertas?.toFixed(2)?.replace('.', ',') || '0,00'}</p>
                      </div>
                    </div>

                    <div className="text-center border-t border-blue-200 pt-3">
                      <p className="text-sm text-blue-700">
                        <strong>{totalGeral.totalDomingos}</strong> domingo{totalGeral.totalDomingos !== 1 ? 's' : ''} com chamadas registradas
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* Botões de Controle Financeiro - Movidos para após a tabela */}
        {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador' || currentUser?.tipo === 'superadmin') && (
          <div className="bg-white p-4 sm:p-6 rounded-lg shadow-lg mt-6">
            <div className="text-center mb-6">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">💼 Controles Financeiros</h3>
              <p className="text-sm text-gray-600">Gerencie pagamentos e fluxo de caixa da EBD</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Botão Controle de Revistas */}
              <div className="text-center">
                <button
                  onClick={() => setCurrentView('revista-pagamentos')}
                  className="w-full px-6 py-4 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-lg hover:from-blue-600 hover:to-indigo-700 transition-all duration-200 flex items-center justify-center"
                >
                  <span className="text-lg mr-2">💳</span>
                  Controlar Pagamento de Revistas
                </button>
                <p className="text-sm text-gray-600 mt-2">Gerencie pagamentos das revistas por aluno</p>
              </div>

              {/* Botão Fluxo de Caixa */}
              <div className="text-center">
                <button
                  onClick={() => setCurrentView('fluxo-caixa')}
                  className="w-full px-6 py-4 bg-gradient-to-r from-green-500 to-blue-600 text-white rounded-lg hover:from-green-600 hover:to-blue-700 transition-all duration-200 flex items-center justify-center"
                >
                  <span className="text-lg mr-2">💰</span>
                  Fluxo de Caixa
                </button>
                <p className="text-sm text-gray-600 mt-2">Controle receitas, despesas e saldo</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HistoricoCompleto;
